import type { IUpcomingMenu } from 'models/UpcomingMenu';
import type Plan from 'models/Plan';
import { ArrivingStatus } from 'models/UpcomingMenu';

/**
 * Returns true if there was a sold out extra in the next scheduled menu.
 * It compares returned extras to the extras in the selected plan. If there
 * is a difference, it assumes something was not available.
 */
const isAnyExtraSoldOut = (upcomingMenus: IUpcomingMenu[], plan: Plan) => {
  const firstScheduledMenu = upcomingMenus.find((item) => (
    item.arriving_status === ArrivingStatus.SCHEDULED
  ));

  if (!firstScheduledMenu) return false;

  const upcomingMenuMealCount = firstScheduledMenu.meals_summaries.reduce(
    (mealCount, mealSummary) => {
      // TODO: do these values need to be pluralized in upcoming_menu_presenter.rb meals_summaries?
      if (['Breakfast', 'Breakfasts', 'Lunch', 'Lunches', 'Dinners'].includes(mealSummary.name)) {
        return mealCount + mealSummary.count;
      }
      return mealCount;
    }, 0,
  );

  const currentPlanMealCount = plan.includedMeals + plan.extras;

  return upcomingMenuMealCount < currentPlanMealCount;
};

function useIsAnyExtraSoldOut(): typeof isAnyExtraSoldOut {
  return isAnyExtraSoldOut;
}

export default useIsAnyExtraSoldOut;
